import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { BrandLockup } from "@/components/brand/BrandLockup";
import { LanguageSwitcher } from "@/components/ui/LanguageSwitcher";
import { ROUTES } from "@/constants/routes";

const PRODUCT_LINKS = [
  { href: "#product-proof", key: "product" },
  { href: "#progress-proof", key: "progress" },
  { href: "#coach-proof", key: "coach" },
  { href: "#pricing", key: "pricing" },
] as const;

const footerLinkClassName =
  "inline-flex min-h-11 items-center text-sm text-muted transition-colors duration-150 hover:text-text focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-text";

export function PublicFooter() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-line bg-bg">
      <div className="mx-auto grid max-w-[1280px] grid-cols-2 gap-x-6 gap-y-10 px-4 py-12 md:px-8 md:py-16 lg:grid-cols-[2fr_1fr_1fr_1fr]">
        <div className="col-span-2 flex flex-col items-start gap-4 lg:col-span-1">
          <BrandLockup compact />
          <p className="text-sm text-muted">&copy; {year} FitnessAppie</p>
        </div>

        <nav aria-labelledby="footer-product-heading" className="flex flex-col items-start">
          <h2 id="footer-product-heading" className="mb-2 text-sm font-semibold text-text">
            {t("frontpage.precision.footer.product")}
          </h2>
          {PRODUCT_LINKS.map((item) => (
            <a key={item.key} href={item.href} className={footerLinkClassName}>
              {t(`frontpage.precision.nav.${item.key}`)}
            </a>
          ))}
        </nav>

        <nav aria-labelledby="footer-legal-heading" className="flex flex-col items-start">
          <h2 id="footer-legal-heading" className="mb-2 text-sm font-semibold text-text">
            {t("frontpage.precision.footer.legal")}
          </h2>
          <Link to={ROUTES.TERMS} className={footerLinkClassName}>
            {t("legal.terms.title")}
          </Link>
          <Link to={ROUTES.PRIVACY} className={footerLinkClassName}>
            {t("legal.privacy.title")}
          </Link>
        </nav>

        <div className="flex flex-col items-start">
          <h2 className="mb-2 text-sm font-semibold text-text">
            {t("frontpage.precision.footer.account")}
          </h2>
          <Link to={ROUTES.LOGIN} className={footerLinkClassName}>
            {t("frontpage.precision.nav.login")}
          </Link>
          <LanguageSwitcher className="mt-3" />
        </div>
      </div>
    </footer>
  );
}
